import React, { useEffect, useState, useRef } from "react";
import ImageAdjuster from "./ImageAdjuster";
import { AUTH_STORAGE_KEY, SERVER_URL, connectSocket } from "../socket";
import { QRCodeCanvas } from "qrcode.react";

function GroupInfoPage({ group, onClose, onLeave, onDelete, onViewProfile, contacts = [], onAddContact }) {
  const [members,      setMembers]      = useState([]);
  const [memberCount,  setMemberCount]  = useState(0);
  const [activeUser,   setActiveUser]   = useState(null);
  const [showAdd,      setShowAdd]      = useState(false);
  const [onlyAdmin,    setOnlyAdmin]    = useState(false);
  const [loading,      setLoading]      = useState({});
  const [groupImg,     setGroupImg]     = useState(group.groupImage || null);
  const [showImgFull,  setShowImgFull]  = useState(false);
  const [menuUser,     setMenuUser]     = useState(null);
  const [adjuster, setAdjuster] = useState(null);
const [memberSearch, setMemberSearch] = useState("");
const [showShare, setShowShare] = useState(false);
const [groupDescription, setGroupDescription] = useState(group.description || "");
const [editingDescription, setEditingDescription] = useState(false);
  // ── Add Member picker state ──
  const [addSearch,         setAddSearch]         = useState("");
  const [selectedNewMembers, setSelectedNewMembers] = useState([]);
  const [adding,            setAdding]            = useState(false);
const [groupName, setGroupName] = useState(group.name);
const [editingName, setEditingName] = useState(false);
const [shareMode, setShareMode] = useState(null); // null | 'link' | 'qr'
const [selectedContacts, setSelectedContacts] = useState([]);
const [shareSearch, setShareSearch] = useState("");
const [qrImageData, setQrImageData] = useState(null);
const qrRef = useRef(null);
  const raw         = localStorage.getItem(AUTH_STORAGE_KEY);
  const parsed      = JSON.parse(raw);
  const currentUser = parsed?.user?.email;

  const isAdmin = members.some(
    m => m.userId?.toLowerCase() === currentUser?.toLowerCase() && m.role === "admin"
  );


  // Contacts not already in the group
  const existingEmails = new Set(members.map(m => m.userId?.toLowerCase()));
  const availableContacts = contacts.filter(c => {
    const email = (c.emails?.[0] || "").toLowerCase();
    if (!email) return false;
    if (existingEmails.has(email)) return false;
    const name = (c.name || "").toLowerCase();
    const q    = addSearch.toLowerCase();
    return !q || name.includes(q) || email.includes(q);
  });

  const toggleNewMember = (email) =>
    setSelectedNewMembers(prev =>
      prev.includes(email) ? prev.filter(e => e !== email) : [...prev, email]
    );

  useEffect(() => {
    const load = async () => {
      const r = localStorage.getItem(AUTH_STORAGE_KEY);
      const p = JSON.parse(r);
      const res  = await fetch(`${SERVER_URL}/api/groups/${group.id}`, {
        headers: { Authorization: `Bearer ${p.token}` },
      });
      const body = await res.json();
      setOnlyAdmin(body.onlyAdmin || false);
      setMembers(body.members    || []);
      setMemberCount(body.memberCount || 0);
    };
    load();
  }, [group]);

  useEffect(() => {
    const handler = () => setMenuUser(null);
    document.addEventListener("click", handler);
    return () => document.removeEventListener("click", handler);
  }, []);
  const updateGroupDescription = async () => {
  const r = localStorage.getItem(AUTH_STORAGE_KEY);
  const p = JSON.parse(r);

  await fetch(`${SERVER_URL}/api/groups/update-description`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${p.token}`,
    },
    body: JSON.stringify({
      groupId: group.id,
      description: groupDescription,
    }),
  });

  setEditingDescription(false);
};

  useEffect(() => {
    if (shareMode === "qr") {
      const timeout = setTimeout(() => generateQRImage(), 150);
      return () => clearTimeout(timeout);
    } else {
      setQrImageData(null);
    }
  }, [shareMode]);
const inviteLink = `${window.location.origin}/join-group/${group.id}`;

const generateQRImage = async () => {
  if (qrRef.current) {
    await new Promise((resolve) => requestAnimationFrame(() => resolve()));
    const canvas = qrRef.current.querySelector('canvas');
    if (canvas) {
      const dataUrl = canvas.toDataURL('image/png');
      setQrImageData(dataUrl);
      return dataUrl;
    }
  }
  return null;
};

const shareGroup = async () => {
  if (navigator.share) {
    await navigator.share({
      title: group.name,
      text: `Join ${group.name}`,
      url: inviteLink,
    });
  } else {
    navigator.clipboard.writeText(inviteLink);
    alert("Invite link copied!");
  }
};
const updateGroupName = async () => {
  const r = localStorage.getItem(AUTH_STORAGE_KEY);
  const p = JSON.parse(r);

  await fetch(`${SERVER_URL}/api/groups/update-name`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${p.token}`,
    },
    body: JSON.stringify({
      groupId: group.id,
      groupName,
    }),
  });

  setEditingName(false);
};
  const setLoadingFor = (uid, val) =>
    setLoading(prev => ({ ...prev, [uid]: val }));

  const togglePermission = async () => {
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const newVal = !onlyAdmin;
    const res = await fetch(`${SERVER_URL}/api/groups/toggle-permission`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, onlyAdmin: newVal }),
    });
    if ((await res.json()).success) setOnlyAdmin(newVal);
  };
const filteredMembers = members.filter(m => {
  const name = m.userId?.split("@")[0]?.toLowerCase() || "";
  const email = m.userId?.toLowerCase() || "";
  const search = memberSearch.toLowerCase();

  return (
    name.includes(search) ||
    email.includes(search)
  );
}); 
  // ── Add selected contacts as members ──
  const addSelectedMembers = async () => {
    if (!selectedNewMembers.length) return;
    setAdding(true);
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    for (const userId of selectedNewMembers) {
      const res = await fetch(`${SERVER_URL}/api/groups/add-member`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
        body: JSON.stringify({ groupId: group.id, userId }),
      });
      if ((await res.json()).success) {
        setMembers(prev => [...prev, { userId, role: "member" }]);
        setMemberCount(prev => prev + 1);
      }
    }
    setSelectedNewMembers([]);
    setAddSearch("");
    setShowAdd(false);
    setAdding(false);
  };

  const removeMember = async (userId) => {
    if (!window.confirm(`Remove ${userId.split("@")[0]}?`)) return;
    setLoadingFor(userId, "removing");
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    await fetch(`${SERVER_URL}/api/groups/remove-member`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, userId }),
    });
    setMembers(prev => prev.filter(m => m.userId !== userId));
    setMemberCount(prev => prev - 1);
    setMenuUser(null);
    setLoadingFor(userId, null);
  };

  const leaveGroup = async () => {
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    await fetch(`${SERVER_URL}/api/groups/leave`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id }),
    });
    onLeave();
  };

  const deleteGroup = async () => {
    if (!window.confirm("Delete this group? This cannot be undone.")) return;
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const res = await fetch(`${SERVER_URL}/api/groups/delete`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id }),
    });
    const body = await res.json();
    if (body.success) {
      // close panel and notify parent to remove group from list
      onClose();
      if (onDelete) onDelete();
    } else {
      alert(body.error || "Failed to delete group");
    }
  };

  const uploadGroupIcon = async (file) => {
    // direct upload (kept for backward compatibility)
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const fd = new FormData();
    fd.append("file", file);
    const res  = await fetch(`${SERVER_URL}/api/groups/upload`, {
      method: "POST", headers: { Authorization: `Bearer ${p.token}` }, body: fd,
    });
    const body = await res.json();
    await fetch(`${SERVER_URL}/api/groups/update-icon`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, groupImage: body.url }),
    });
    setGroupImg(body.url);
  };

  const handleAdjusterConfirm = async (croppedFile) => {
    setAdjuster(null);
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const fd = new FormData();
    fd.append("file", croppedFile);
    const res  = await fetch(`${SERVER_URL}/api/groups/upload`, {
      method: "POST", headers: { Authorization: `Bearer ${p.token}` }, body: fd,
    });
    const body = await res.json();
    await fetch(`${SERVER_URL}/api/groups/update-icon`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, groupImage: body.url }),
    });
    setGroupImg(body.url);
  };

  const makeAdmin = async (userId) => {
    setLoadingFor(userId, "admin");
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const res = await fetch(`${SERVER_URL}/api/groups/make-admin`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, userId }),
    });
    if ((await res.json()).success)
      setMembers(prev => prev.map(m => m.userId === userId ? { ...m, role: "admin" } : m));
    setMenuUser(null);
    setLoadingFor(userId, null);
  };

  const removeAdmin = async (userId) => {
    setLoadingFor(userId, "removeAdmin");
    const r = localStorage.getItem(AUTH_STORAGE_KEY);
    const p = JSON.parse(r);
    const res = await fetch(`${SERVER_URL}/api/groups/remove-admin`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${p.token}` },
      body: JSON.stringify({ groupId: group.id, userId }),
    });
    if ((await res.json()).success)
      setMembers(prev => prev.map(m => m.userId === userId ? { ...m, role: "member" } : m));
    setMenuUser(null);
    setLoadingFor(userId, null);
  };

  const avatarColors = ["#1e40af","#0f766e","#7c3aed","#b45309","#be123c","#166534"];
  const colorFor = (s) => avatarColors[(s?.charCodeAt(0) || 0) % avatarColors.length];
  const isSavedContact = (email) => contacts.some(c =>
    (c.emails || [c.email || c.contactId || c.id]).some(item =>
      String(item).toLowerCase() === String(email || "").toLowerCase()
    )
  );

  return (
    <>
      {/* ── Backdrop ── */}
      <div onClick={onClose} style={{
        position: "fixed", inset: 0,
        background: "rgba(0,0,0,0.4)", zIndex: 1040,
      }} />

      {/* ── Right panel ── */}
      <div style={{
        position: "fixed", top: 0, right: 0, bottom: 0,
        width: "min(380px,100vw)",
        background: "#050505",
        borderLeft: "1px solid #1e2d40",
        zIndex: 90000,
        display: "flex", flexDirection: "column",
      }}>

        {/* ── Header / Group avatar section ── */}
        <div style={{
          background: "linear-gradient(180deg,#0f1a2d,#050505)",
          padding: "20px 20px 18px",
          borderBottom: "1px solid #1e2d40",
        }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <p style={{
              color: "#f57011", fontSize: 11, fontWeight: 700,
              letterSpacing: 1, margin: 0, textAlign: "left",
            }}>Group info</p>

            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
              <button onClick={() => setShowShare(true)} style={{
                background: "none", border: "none", color: "#94a3b8",
                fontSize: 18, cursor: "pointer", padding: 6,
              }} aria-label="Share group">🔗</button>

              <button onClick={onClose} style={{
                background: "none", border: "none", color: "#94a3b8",
                fontSize: 20, cursor: "pointer", padding: 6,
              }} aria-label="Close">✕</button>
            </div>
          </div>

{showShare && (
  <div
    onClick={() => { setShowShare(false); setShareMode(null); setSelectedContacts([]); setShareSearch(""); }}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.7)",
      zIndex: 100001,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      style={{
        width: "min(90vw, 380px)",
        maxHeight: "80vh",
        background: "#0a1628",
        borderRadius: 16,
        padding: 20,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Initial view: 3 options */}
      {!shareMode && (
        <>
          <h3 style={{ color: "#fff", margin: "0 0 16px", textAlign: "center" }}>Invite to {groupName}</h3>

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <button
              onClick={() => { setShareMode("link"); setSelectedContacts([]); setShareSearch(""); }}
              style={{
                padding: "12px 16px",
                background: "#1e3a5f",
                color: "#fff",
                border: "1px solid #3b5998",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              🔗 Share Link
            </button>

            <button
              onClick={() => { setShareMode("qr"); setSelectedContacts([]); setShareSearch(""); }}
              style={{
                padding: "12px 16px",
                background: "#1e3a5f",
                color: "#fff",
                border: "1px solid #3b5998",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 14,
                fontWeight: 600,
              }}
            >
              📷 Share QR Code
            </button>

            <button
              onClick={() => {
                navigator.clipboard.writeText(inviteLink);
                alert("Link copied to clipboard!");
              }}
              style={{
                padding: "12px 16px",
                background: "#0f1724",
                color: "#94a3b8",
                border: "1px solid rgba(255,255,255,0.04)",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 14,
              }}
            >
              📋 Copy Link
            </button>
          </div>
        </>
      )}

      {/* Contact selection view */}
      {shareMode && (
        <>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
            <h3 style={{ color: "#fff", margin: 0, fontSize: 16 }}>
              {shareMode === "link" ? "Share Link" : "Share QR Code"}
            </h3>
            <button
              onClick={() => { setShareMode(null); setSelectedContacts([]); setShareSearch(""); }}
              style={{
                background: "none",
                border: "none",
                color: "#94a3b8",
                fontSize: 18,
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          </div>

          {/* QR Code Image Display */}
          {shareMode === "qr" && (
            <div style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginBottom: 16,
              padding: 12,
              background: "rgba(255,255,255,0.05)",
              borderRadius: 8,
            }}>
              <div ref={qrRef} style={{ position: "absolute", left: -9999, top: -9999, width: 256, height: 256, opacity: 0, pointerEvents: "none" }}>
                <QRCodeCanvas value={inviteLink} size={256} level="H" includeMargin />
              </div>
              {qrImageData && (
                <img 
                  src={qrImageData} 
                  alt="Group QR Code" 
                  style={{
                    width: 200,
                    height: 200,
                    borderRadius: 8,
                    border: "2px solid #3b5998",
                  }}
                />
              )}
              <p style={{ color: "#cbd5e1", fontSize: 12, marginTop: 8, textAlign: "center" }}>
                Scan to join {groupName}
              </p>
            </div>
          )}

          <input
            type="text"
            placeholder="Search contacts..."
            value={shareSearch}
            onChange={(e) => setShareSearch(e.target.value)}
            style={{
              padding: "8px 12px",
              marginBottom: 12,
              background: "#0f1a2d",
              border: "1px solid #1e2d40",
              borderRadius: 8,
              color: "#fff",
              fontSize: 13,
            }}
          />

          <div style={{
            flex: 1,
            overflowY: "auto",
            borderRadius: 8,
            background: "rgba(255,255,255,0.02)",
            padding: 8,
            marginBottom: 12,
          }}>
            {contacts.length === 0 && (
              <div style={{ color: "#94a3b8", textAlign: "center", padding: 16 }}>
                No contacts
              </div>
            )}

            {contacts
              .filter((c) => {
                const email = (c.emails?.[0] || c.email || c.contactId || c.id || "").toLowerCase();
                const name = (c.name || "").toLowerCase();
                const q = shareSearch.toLowerCase();
                return email.includes(q) || name.includes(q);
              })
              .slice(0, 50)
              .map((c) => {
                const email = c.emails?.[0] || c.email || c.contactId || c.id || "";
                const isSelected = selectedContacts.includes(email);
                return (
                  <div
                    key={email}
                    onClick={() =>
                      setSelectedContacts((prev) =>
                        isSelected ? prev.filter((e) => e !== email) : [...prev, email]
                      )
                    }
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                      padding: "12px 8px",
                      borderRadius: 8,
                      background: isSelected ? "rgba(30,58,95,0.4)" : "transparent",
                      cursor: "pointer",
                      transition: "background 0.2s",
                      borderBottom: "1px solid rgba(255,255,255,0.02)",
                      hover: { background: "rgba(255,255,255,0.05)" },
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={isSelected}
                      onChange={() => {}}
                      style={{ cursor: "pointer",width: 16 }}
                    />
                    <div style={{
                      width: 32,
                      height: 32,
                      borderRadius: 6,
                      background: colorFor(email),
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#fff",
                      fontWeight: 700,
                      fontSize: 12,
                    }}>
                      {(c.name || email)[0]?.toUpperCase()}
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      {c.name && (
                        <div style={{ fontSize: 13, color: "#fff", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", fontWeight: 600 }}>
                          {c.name}
                        </div>
                      )}
                      <div style={{ fontSize: 12, color: "#cbd5e1", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", marginTop: c.name ? 2 : 0 }}>
                        {email}
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={async () => {
                if (selectedContacts.length === 0) {
                  alert("Select at least one contact");
                  return;
                }

                try {
                  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
                  const p = JSON.parse(raw);
                  if (!p?.token) {
                    alert("Sign in to send invite");
                    return;
                  }

                  const socket = connectSocket();
                  
                  // Wait for socket to be connected
                  if (!socket.connected) {
                    await new Promise((resolve) => {
                      if (socket.connected) {
                        resolve();
                      } else {
                        socket.once("connect", resolve);
                      }
                    });
                  }

                  // Generate QR image if in QR mode and not already generated
                  let imageData = qrImageData;
                  if (shareMode === "qr" && !imageData) {
                    imageData = await generateQRImage();
                  }

                  for (const email of selectedContacts) {
                    if (shareMode === "qr" && imageData) {
                      // Send QR code image
                      const msg = {
                        from: p.user.email,
                        to: email,
                        text: `Join ${groupName} via QR Code: ${inviteLink}`,
                        timestamp: Date.now(),
                        clientId: String(Date.now() + Math.random()),
                        attachmentUrl: imageData,
                        type: "qr"
                      };
                      socket.emit("chat_message", msg);
                    } else {
                      // Send link
                      const msg = {
                        from: p.user.email,
                        to: email,
                        text: `Join ${groupName}: ${inviteLink}`,
                        timestamp: Date.now(),
                        clientId: String(Date.now() + Math.random()),
                      };
                      socket.emit("chat_message", msg);
                    }
                    console.log("Message sent to:", email);
                  }

                  alert(`Invite sent to ${selectedContacts.length} contact(s)!`);
                  setShowShare(false);
                  setShareMode(null);
                  setSelectedContacts([]);
                  setShareSearch("");
                } catch (e) {
                  console.error("Send failed", e);
                  alert("Failed to send invites");
                }
              }}
              style={{
                flex: 1,
                padding: "10px 12px",
                background: "#1e3a5f",
                color: "#fff",
                border: "1px solid #3b5998",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              Send to {selectedContacts.length > 0 ? selectedContacts.length : "..."}
            </button>

            <button
              onClick={() => { setShowShare(false); setShareMode(null); setSelectedContacts([]); setShareSearch(""); }}
              style={{
                flex: 1,
                padding: "10px 12px",
                background: "#0f1724",
                color: "#94a3b8",
                border: "1px solid rgba(255,255,255,0.04)",
                borderRadius: 8,
                cursor: "pointer",
                fontSize: 13,
              }}
            >
              Cancel
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)}
          <div
            onClick={() => groupImg && setShowImgFull(true)}
            style={{
              width: 90, height: 90, borderRadius: "50%",
              border: "3px solid #f57011",
              margin: "0 auto 12px",
              overflow: "hidden", cursor: groupImg ? "pointer" : "default",
              display: "flex", alignItems: "center", justifyContent: "center",
              background: groupImg ? "#000" : colorFor(group.name),
              fontSize: 34, fontWeight: 700, color: "#fff",
              position: "relative",
            }}
          >
            {groupImg
              ? <img src={`${SERVER_URL}${groupImg}`} alt="group"
                  style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              : (group.name || "G")[0].toUpperCase()
            }
            {isAdmin && (
              <label style={{
                position: "absolute", inset: 0,
                display: "flex", alignItems: "center", justifyContent: "center",
                background: "rgba(0,0,0,0.45)",
                opacity: 0, transition: "opacity 0.2s",
                cursor: "pointer", fontSize: 22,
              }}
              onMouseEnter={e => e.currentTarget.style.opacity = 1}
              onMouseLeave={e => e.currentTarget.style.opacity = 0}
              >
                📷
                <input type="file" accept="image/*" style={{ display: "none" }}
                  onChange={e => { const f = e.target.files[0]; if (f) setAdjuster({ file: f, aspectRatio: 1 }); e.target.value = ""; }} />
              </label>
            )}
          </div>

         {editingName ? (
  <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
    <input
      value={groupName}
      onChange={(e) => setGroupName(e.target.value)}
      style={{
        padding: "6px 10px",
        borderRadius: 8,
        border: "1px solid #1e3a5f",
        background: "#0f1a2d",
        color: "#fff",
        textAlign: "center",
      }}
    />
    <button
      onClick={updateGroupName}
      style={{
        background: "#f57011",
        border: "none",
        color: "#fff",
        borderRadius: 8,
        padding: "6px 12px",
        cursor: "pointer",
      }}
    >
      Save
    </button>
  </div>
) : (
  <div
    onClick={() => isAdmin && setEditingName(true)}
    style={{
      color: "#f1f5f9",
      fontSize: 17,
      fontWeight: 700,
      cursor: isAdmin ? "pointer" : "default",
    }}
  >
    {groupName} {isAdmin && "✏️"}
  </div>
)}
{editingDescription ? (
  <div style={{ marginTop: 10 }}>
    <textarea
      value={groupDescription}
      onChange={(e) => setGroupDescription(e.target.value)}
      rows={3}
      placeholder="Enter group description"
      style={{
        width: "100%",
        padding: "8px 10px",
        borderRadius: 8,
        border: "1px solid #1e3a5f",
        background: "#0f1a2d",
        color: "#fff",
        resize: "none",
        boxSizing: "border-box",
      }}
    />
    <button
      onClick={updateGroupDescription}
      style={{
        marginTop: 8,
        background: "#f57011",
        color: "#fff",
        border: "none",
        borderRadius: 8,
        padding: "6px 14px",
        cursor: "pointer",
      }}
    >
      Save
    </button>
  </div>
) : (
  <div
    onClick={() => isAdmin && setEditingDescription(true)}
    style={{
      marginTop: 8,
      color: "#cbd5e1",
      fontSize: 13,
      cursor: isAdmin ? "pointer" : "default",
      whiteSpace: "pre-wrap",
    }}
  >
    {groupDescription || "Add group description"} {isAdmin && "✏️"}
  </div>
)}
          <div style={{ color: "#64748b", fontSize: 12, marginTop: 3 }}>
            Group · {memberCount} member{memberCount !== 1 ? "s" : ""}
          </div>
        </div>

        {/* ── Scrollable body ── */}
        <div style={{ flex: 1, overflowY: "auto", paddingBottom: 80 }}>
          {isAdmin && (
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "14px 18px",
              borderBottom: "1px solid #1e2d40",
            }}>
              <div>
                <div style={{ color: "#f1f5f9", fontSize: 13, fontWeight: 600 }}>
                  🔒 Only admins can send
                </div>
                <div style={{ color: "#64748b", fontSize: 11, marginTop: 2 }}>
                  {onlyAdmin ? "Restricted to admins" : "All members can send"}
                </div>
              </div>
              <label className="switch">
                <input type="checkbox" checked={onlyAdmin} onChange={togglePermission} />
                <span className="slider" />
              </label>
            </div>
          )}

        <div style={{
  color: "#f57011",
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: 1,
  padding: "14px 18px 6px",
}}>
  {memberCount} MEMBERS
</div>

<div style={{ padding: "0 18px 12px" }}>
  <input
    type="text"
    placeholder="🔍 Search member..."
    value={memberSearch}
    onChange={(e) => setMemberSearch(e.target.value)}
    style={{
      width: "100%",
      padding: "10px 12px",
      background: "#1a2a42",
      border: "1px solid #1e3a5f",
      borderRadius: "8px",
      color: "#fff",
      fontSize: "13px",
      outline: "none",
      boxSizing: "border-box"
    }}
  />
</div>

          {filteredMembers.map(m => {
            const isMe   = m.userId?.toLowerCase() === currentUser?.toLowerCase();
            const name   = m.userId?.split("@")[0] || m.userId;
            const busy   = loading[m.userId];
            const menuOpen = menuUser === m.userId;
            const saved = isSavedContact(m.userId);

            return (
              <div key={m.userId} style={{
                borderBottom: "1px solid #1e2d40",
                position: "relative",
              }}>
               <div style={{
  display: "flex",
  alignItems: "center",
  padding: "10px 18px",
  cursor: isAdmin ? "pointer" : "default",
}}
  onClick={() => {
    if (isAdmin && onViewProfile) {
      onViewProfile(m.userId);
    }
  }}
>
                  <div style={{
                    width: 44, height: 44, borderRadius: "50%",
                    background: colorFor(m.userId),
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontWeight: 700, fontSize: 18, color: "#fff",
                    flexShrink: 0, marginRight: 12,
                  }}>
                    {(m.userId || "?")[0].toUpperCase()}
                  </div>

                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 5, flexWrap: "wrap" }}>
                      <span style={{
                        color: "#f1f5f9", fontSize: 14, fontWeight: 600,
                        whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                      }}>{name}</span>
                      {isMe && (
                        <span style={{
                          background: "#064e3b", color: "#34d399",
                          fontSize: 10, fontWeight: 600,
                          padding: "1px 6px", borderRadius: 20,
                        }}>You</span>
                      )}
                      {m.role === "admin" && (
                        <span style={{
                          background: "linear-gradient(135deg,#4f46e5,#6366f1)",
                          color: "#fff", fontSize: 10, fontWeight: 700,
                          padding: "1px 7px", borderRadius: 20,
                        }}>⭐ Admin</span>
                      )}
                      {saved && (
                        <span style={{
                          background: "rgba(34,197,94,0.14)",
                          color: "#86efac",
                          fontSize: 10, fontWeight: 700,
                          padding: "1px 7px", borderRadius: 20,
                          border: "1px solid rgba(34,197,94,0.25)",
                        }}>✓ Saved</span>
                      )}
                    </div>
                   <div style={{ color: "#64748b", fontSize: 11, marginTop: 2 }}>
  {isAdmin
    ? m.userId
    : (() => {
        const n = m.userId?.split("@")[0] || "";
        return n.length > 3
          ? `${n.substring(0, 3)}...`
          : `${n}...`;
      })()
  }
</div>
                  </div>

                  {isAdmin && !isMe && (
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        setMenuUser(menuOpen ? null : m.userId);
                      }}
                      style={{
                        background: "none", border: "none",
                        color: "#64748b", fontSize: 18,
                        cursor: "pointer", padding: "4px 6px",
                        flexShrink: 0, lineHeight: 1,
                        transform: menuOpen ? "rotate(90deg)" : "rotate(0deg)",
                        transition: "transform 0.2s",
                      }}
                    >›</button>
                  )}
                </div>

                {isAdmin && !isMe && menuOpen && (
                  <div
                    onClick={e => e.stopPropagation()}
                    style={{
                      position: "absolute",
                      top: 0, right: 44,
                      background: "#0f1a2d",
                      border: "1px solid #1e3a5f",
                      borderRadius: 10,
                      minWidth: 175,
                      zIndex: 100,
                      boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
                      overflow: "hidden",
                    }}
                  >
                    {m.role !== "admin" ? (
                      <button
                        disabled={!!busy}
                        onClick={() => makeAdmin(m.userId)}
                        style={menuBtnStyle("#4f46e5")}
                      >
                        ⭐ {busy === "admin" ? "Making admin..." : "Make Admin"}
                      </button>
                    ) : (
                      <button
                        disabled={!!busy}
                        onClick={() => removeAdmin(m.userId)}
                        style={menuBtnStyle("#b45309")}
                      >
                        ↩ {busy === "removeAdmin" ? "Removing..." : "Remove Admin"}
                      </button>
                    )}
                    <div style={{ height: 1, background: "#1e3a5f" }} />
                    {saved ? (
                      <button
                        disabled
                        style={{
                          ...menuBtnStyle("#22c55e"),
                          cursor: "default",
                          opacity: 0.9,
                        }}
                      >
                        ✓ Already Saved
                      </button>
                    ) : typeof onAddContact === "function" && (
                      <button
                        onClick={async () => {
                          try {
                            await onAddContact(m.userId, name);
                          } finally {
                            setMenuUser(null);
                          }
                        }}
                        style={menuBtnStyle("#22c55e")}
                      >
                        ➕ Save Contact
                      </button>
                    )}
                    <div style={{ height: 1, background: "#1e3a5f" }} />
                    <button
                      onClick={() => { onViewProfile && onViewProfile(m.userId); setMenuUser(null); }}
                      style={menuBtnStyle("#0f766e")}
                    >
                      👤 View Profile
                    </button>
                    <div style={{ height: 1, background: "#1e3a5f" }} />
                    <button
                      disabled={!!busy}
                      onClick={() => removeMember(m.userId)}
                      style={menuBtnStyle("#be123c")}
                    >
                      🗑 {busy === "removing" ? "Removing..." : "Remove Member"}
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* ── Bottom bar ── */}
        <div style={{
          position: "absolute", bottom: 0, left: 0, right: 0,
          display: "flex", gap: 8, padding: "12px 16px",
          background: "#050505", borderTop: "1px solid #1e2d40",
        }}>
          <button onClick={leaveGroup} style={{
            flex: 1, border: "none", borderRadius: 10,
            padding: "11px 0", fontSize: 13, fontWeight: 700,
            cursor: "pointer", color: "#fff",
            background: "linear-gradient(135deg,#be123c,#e11d48)",
          }}>🚪 Leave Group</button>

          {isAdmin && (
            <>
              <button onClick={() => { setShowAdd(true); setSelectedNewMembers([]); setAddSearch(""); }} style={{
                flex: 1, border: "none", borderRadius: 10,
                padding: "11px 0", fontSize: 13, fontWeight: 700,
                cursor: "pointer", color: "#fff",
                background: "linear-gradient(135deg,#1e40af,#3b82f6)",
              }}>➕ Add Member</button>

              <button onClick={deleteGroup} style={{ display: "none",
                flex: 1, border: "none", borderRadius: 10,
                padding: "11px 0", fontSize: 13, fontWeight: 700,
                cursor: "pointer", color: "#fff",
                background: "linear-gradient(135deg,#7f1d1d,#ef4444)",
              }}>🗑 Delete Group</button>
            </>
          )}
        </div>
      </div>

      {/* ── Full-screen image viewer ── */}
      {showImgFull && groupImg && (
        <div
          onClick={() => setShowImgFull(false)}
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.95)",
            zIndex: 2000,
            display: "flex", alignItems: "center", justifyContent: "center",
          }}
        >
          <button onClick={() => setShowImgFull(false)} style={{
            position: "absolute", top: 16, right: 20,
            background: "none", border: "none",
            color: "#fff", fontSize: 28, cursor: "pointer",
          }}>✕</button>
          <img
            src={`${SERVER_URL}${groupImg}`}
            alt="group"
            style={{
              maxWidth: "90vw", maxHeight: "90vh",
              borderRadius: 12, objectFit: "contain",
              boxShadow: "0 0 60px rgba(0,0,0,0.8)",
            }}
          />
        </div>
      )}

      {adjuster && (
        <ImageAdjuster file={adjuster.file} aspectRatio={adjuster.aspectRatio} onConfirm={handleAdjusterConfirm} onCancel={() => setAdjuster(null)} />
      )}

      {/* ══════════════════════════════════════════════
          ── Add Member — Contact List Picker Modal ──
         ══════════════════════════════════════════════ */}
      {showAdd && (
        <div
          style={{
            position: "fixed", inset: 0,
            background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 100000,
          }}
          onClick={() => setShowAdd(false)}
        >
          <div
            style={{
              background: "#0a1628",
              border: "1px solid #1e3a5f",
              borderRadius: 16,
              width: "min(420px, 94vw)",
              maxHeight: "80vh",
              display: "flex", flexDirection: "column",
              overflow: "hidden",
              boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Header */}
            <div style={{
              display: "flex", alignItems: "center", justifyContent: "space-between",
              padding: "16px 18px",
              borderBottom: "1px solid #1e3a5f",
            }}>
              <span style={{ color: "#f1f5f9", fontSize: 16, fontWeight: 700 }}>
                ➕ Add Members
              </span>
              <button
                onClick={() => setShowAdd(false)}
                style={{ background: "none", border: "none", color: "#94a3b8", fontSize: 20, cursor: "pointer" }}
              >✕</button>
            </div>

            {/* Search */}
            <div style={{ padding: "12px 18px", borderBottom: "1px solid #1e3a5f" }}>
              <input
                type="text"
                autoFocus
                placeholder="Search contacts..."
                value={addSearch}
                onChange={e => setAddSearch(e.target.value)}
                style={{
                  width: "100%", padding: "9px 12px",
                  background: "#1a2a42", border: "1px solid #1e3a5f",
                  borderRadius: 8, color: "#f1f5f9", fontSize: 14,
                  boxSizing: "border-box", outline: "none",
                }}
              />
            </div>

            {/* Selected chips */}
            {selectedNewMembers.length > 0 && (
              <div style={{
                display: "flex", flexWrap: "wrap", gap: 6,
                padding: "8px 18px",
                borderBottom: "1px solid #1e3a5f",
                maxHeight: 80, overflowY: "auto",
              }}>
                {selectedNewMembers.map(email => {
                  const c    = contacts.find(c => c.emails?.[0] === email);
                  const name = c?.name || email.split("@")[0];
                  return (
                    <span
                      key={email}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: 4,
                        background: "rgba(37,99,235,0.25)", color: "#60a5fa",
                        borderRadius: 20, padding: "3px 10px", fontSize: 12,
                        border: "1px solid rgba(37,99,235,0.4)",
                      }}
                    >
                      {name}
                      <span
                        style={{ cursor: "pointer", fontWeight: 700, fontSize: 14 }}
                        onClick={() => toggleNewMember(email)}
                      >×</span>
                    </span>
                  );
                })}
              </div>
            )}

            {/* Contact list */}
            <div style={{ flex: 1, overflowY: "auto" }}>
              {availableContacts.length === 0 && (
                <p style={{ textAlign: "center", color: "#64748b", padding: "24px 16px", fontSize: 13 }}>
                  {contacts.length === 0
                    ? "No contacts available"
                    : "All contacts are already in the group"}
                </p>
              )}

              {availableContacts.map(c => {
                const email    = c.emails?.[0] || "";
                const name     = c.name || email;
                const selected = selectedNewMembers.includes(email);
                const initial  = name.charAt(0).toUpperCase();

                return (
                  <div
                    key={email}
                    onClick={() => toggleNewMember(email)}
                    style={{
                      display: "flex", alignItems: "center", gap: 12,
                      padding: "10px 18px",
                      cursor: "pointer",
                      borderBottom: "1px solid #1e2d40",
                      background: selected ? "rgba(37,99,235,0.12)" : "transparent",
                      transition: "background 0.15s",
                    }}
                  >
                    {/* Avatar */}
                    <div style={{
                      width: 40, height: 40, borderRadius: "50%",
                      background: selected ? "#1e40af" : colorFor(email),
                      color: "#fff",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      fontWeight: 700, fontSize: 16, flexShrink: 0,
                      transition: "background 0.15s",
                    }}>
                      {selected ? "✔" : initial}
                    </div>

                    {/* Info */}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ color: "#f1f5f9", fontSize: 14, fontWeight: 600 }}>{name}</div>
                      <div style={{ color: "#64748b", fontSize: 12, marginTop: 1 }}>{email}</div>
                    </div>

                    {/* Checkbox indicator */}
                    <div style={{
                      width: 20, height: 20, borderRadius: "50%",
                      border: selected ? "2px solid #3b82f6" : "2px solid #334155",
                      background: selected ? "#3b82f6" : "transparent",
                      display: "flex", alignItems: "center", justifyContent: "center",
                      flexShrink: 0, transition: "all 0.15s",
                    }}>
                      {selected && (
                        <svg viewBox="0 0 12 10" width="10" height="10" fill="white">
                          <path d="M1 5l3.5 3.5L11 1" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Footer buttons */}
            <div style={{
              display: "flex", gap: 8, padding: "12px 18px",
              borderTop: "1px solid #1e3a5f",
              background: "#0a1628",
            }}>
              <button
                onClick={() => setShowAdd(false)}
                style={{
                  flex: 1, border: "1px solid #1e3a5f", borderRadius: 10,
                  padding: "10px 0", fontSize: 13, fontWeight: 600,
                  cursor: "pointer", color: "#94a3b8", background: "transparent",
                }}
              >Cancel</button>
              <button
                onClick={addSelectedMembers}
                disabled={!selectedNewMembers.length || adding}
                style={{
                  flex: 2, border: "none", borderRadius: 10,
                  padding: "10px 0", fontSize: 13, fontWeight: 700,
                  cursor: selectedNewMembers.length ? "pointer" : "not-allowed",
                  color: "#fff",
                  background: selectedNewMembers.length
                    ? "linear-gradient(135deg,#1e40af,#3b82f6)"
                    : "#1e2d40",
                  opacity: selectedNewMembers.length ? 1 : 0.5,
                  transition: "all 0.2s",
                }}
              >
                {adding
                  ? "Adding..."
                  : selectedNewMembers.length > 0
                    ? `Add ${selectedNewMembers.length} Member${selectedNewMembers.length > 1 ? "s" : ""} ✔`
                    : "Select members"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function menuBtnStyle(accentColor) {
  return {
    width: "100%", border: "none",
    background: "transparent",
    color: "#f1f5f9",
    padding: "11px 16px",
    fontSize: 13, fontWeight: 600,
    textAlign: "left", cursor: "pointer",
    display: "flex", alignItems: "center", gap: 8,
    transition: "background 0.15s",
    borderLeft: `3px solid ${accentColor}`,
  };
}

export default GroupInfoPage;
